import React, { Component } from "react";
import {
  Button,
  Form,
  InputGroup,
  FormControl,
  Row,
  Col,
} from "react-bootstrap";
import { PAPER_SIZE, ORIENTATION } from "../../../../com/lib/config/enums";
import ColorPicker from "../../../../com/lib/plugins/color-picker/ColorPicker";
import {
  changeProprty,
  changeProprtyM,
} from "../../../../com/lib/global/helpers";
import { uploadImage } from "../../../../com/lib/api/data/Image";
import { connect } from "react-redux";
import {
  updateProp,
  updateHead,
  updateTotal,
  updateFoot
} from "../../../../redux/actions/TemplateActions";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(faLightbulb);

class Properties extends Component {
  constructor(props) {
    super(props);
    //this.props.callbackFromParents(this.props.properties);
    this.state = {
      backgroundImagePreview: this.props.properties.background.image || null,
      backgroundImageFile: null,
      backgroundImageOpacity: this.props.properties.background.opacity || 1.0,
      backgroundImageSize: this.props.properties.background.imageSize || 100,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.properties.background.image !== prevProps.properties.background.image) {
      this.setState({
        backgroundImagePreview: this.props.properties.background.image || null
      });
    }

    if (this.props.properties.background.imageSize !== prevProps.properties.background.imageSize) {
      this.setState({
        backgroundImageSize: this.props.properties.background.imageSize || 100
      });
    }

    if (this.props.properties.background.opacity !== prevProps.properties.background.opacity) {
      this.setState({
        backgroundImageOpacity: this.props.properties.background.opacity || 1.0
      });
    }
  }

  componentWillUnmount() {
    if (this.state.backgroundImagePreview && this.state.backgroundImagePreview.startsWith('blob:')) {
      URL.revokeObjectURL(this.state.backgroundImagePreview);
    }
  }

  _updateAllFonts = (fontColor, fontSize) => {
    const updatedProp = {
      ...this.props.properties,
      fontColor,
      fontSize
    };
    this.props.updateProp(updatedProp);

    const headFont = this.props.head?.font || {};
    const updatedHead = {
      ...this.props.head,
      font: {
        ...headFont,
        color: fontColor,
        fontSize: parseInt(fontSize)
      }
    };
    this.props.updateHead(updatedHead);

    const totalFont = this.props.total?.font || {};
    const updatedTotal = {
      ...this.props.total,
      font: {
        ...totalFont,
        color: fontColor,
        fontSize: parseInt(fontSize)
      }
    };
    this.props.updateTotal(updatedTotal);

    const footFont = this.props.foot?.font || {};
    const updatedFoot = {
      ...this.props.foot,
      font: {
        ...footFont,
        color: fontColor,
        fontSize: parseInt(fontSize)
      }
    };
    this.props.updateFoot(updatedFoot);
  };

  _handleBackgroundImageSelect = async (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];

      if (
        img.type !== "image/png" &&
        img.type !== "image/jpeg" &&
        img.type !== "image/jpg"
      ) {
        alert(`${img.name} is not an image file`);
        return false;
      }

      const previewUrl = URL.createObjectURL(img);

      this.setState({
        backgroundImagePreview: previewUrl,
        backgroundImageFile: img,
        backgroundImageSize: 100
      });

      uploadImage(img).then((result) => {
        if (result.data && result.status === 200) {
          const updatedProp = {
            ...this.props.properties,
            background: {
              ...this.props.properties.background,
              image: result.data.Result,
              showImage: true
            }
          };
          this.props.updateProp(updatedProp);
        }
      });

      // const reader = new FileReader();
      // reader.onloadend = () => {
      //   const base64String = reader.result;

      //   const updatedProp = {
      //     ...this.props.properties,
      //     background: {
      //       ...this.props.properties.background,
      //       image: base64String,
      //       showImage: true,
      //       imageSize: 100,
      //       opacity: 1.0
      //     }
      //   };
      // this.props.updateProp(updatedProp);
      // };
      // reader.readAsDataURL(img);
    }
  };

  _handleRemoveBackgroundImage = () => {
    if (this.state.backgroundImagePreview && this.state.backgroundImagePreview.startsWith('blob:')) {
      URL.revokeObjectURL(this.state.backgroundImagePreview);
    }
    this.setState({
      backgroundImagePreview: null,
      backgroundImageFile: null,
      backgroundImageSize: 100,
      backgroundImageOpacity: 1.0
    });

    const updatedProp = {
      ...this.props.properties,
      background: {
        ...this.props.properties.background,
        image: null,
        showImage: true,
        imageSize: 100,
        opacity: 1.0
      }
    };
    this.props.updateProp(updatedProp);
  };

  _handleImageSizeChange = (e) => {
    const size = e.target.value;
    this.setState({ backgroundImageSize: size });

    const updatedProp = {
      ...this.props.properties,
      background: {
        ...this.props.properties.background,
        imageSize: size
      }
    };
    this.props.updateProp(updatedProp);
  };

  _handleImageOpacityChange = (e) => {
    const opacity = e.target.value;
    this.setState({ backgroundImageOpacity: opacity });

    const updatedProp = {
      ...this.props.properties,
      background: {
        ...this.props.properties.background,
        opacity: opacity
      }
    };
    this.props.updateProp(updatedProp);
  };

  render() {
    return (
      <>
        <div className="column-header">
          <span className="font-large">Template Properties</span>
          <Button
            variant="link ml-2"
            className="text-dark text-decoration-none"
            onClick={(e) => {
              this.props.showToolTips(true);
            }}
          >
            <FontAwesomeIcon icon="lightbulb" className="me-2" />
            Tool Tips
          </Button>
        </div>
        <div className="column-body">
          {typeof this.props.properties !== "undefined" ? (
            <Form>
              <Row>
                <Col>
                  <Form.Group controlId="formTemplateName">
                    <Form.Label className="fw-bold">Template Name</Form.Label>
                    <Form.Control
                      value={this.props.properties.templateName}
                      onChange={(e) =>
                        changeProprty(
                          "templateName",
                          e.target.value,
                          this.props,
                          this.props.updateProp
                        )
                      }
                      required
                      type="text"
                    />
                    <Form.Control.Feedback type="invalid">
                      Template name is required
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>Paper Size</Form.Label>
                    <Form.Check
                      checked={
                        this.props.properties.paperSize === PAPER_SIZE.A4
                          ? true
                          : false
                      }
                      onChange={(e) =>
                        changeProprty(
                          "paperSize",
                          PAPER_SIZE.A4,
                          this.props,
                          this.props.updateProp
                        )
                      }
                      inline
                      label="A4"
                      name="paperSizeA4"
                      type="radio"
                    />
                    <Form.Check
                      checked={
                        this.props.properties.paperSize === PAPER_SIZE.LETTER
                          ? true
                          : false
                      }
                      onChange={(e) =>
                        changeProprty(
                          "paperSize",
                          PAPER_SIZE.LETTER,
                          this.props,
                          this.props.updateProp
                        )
                      }
                      inline
                      label="Letter"
                      name="paperSizeLetter"
                      type="radio"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>Orientation</Form.Label>
                    <Form.Check
                      checked={
                        this.props.properties.orientation ===
                          ORIENTATION.PORTRAIT
                          ? true
                          : false
                      }
                      onChange={(e) =>
                        changeProprty(
                          "orientation",
                          ORIENTATION.PORTRAIT,
                          this.props,
                          this.props.updateProp
                        )
                      }
                      inline
                      label="Portrait"
                      name="paperOrientationPotrait"
                      type="radio"
                    />
                    <Form.Check
                      checked={
                        this.props.properties.orientation ===
                          ORIENTATION.LANDSCAPE
                          ? true
                          : false
                      }
                      onChange={(e) =>
                        changeProprty(
                          "orientation",
                          ORIENTATION.LANDSCAPE,
                          this.props,
                          this.props.updateProp
                        )
                      }
                      inline
                      label="Landscape"
                      name="paperOrientationLandscape"
                      type="radio"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group controlId="formMargins">
                    <Form.Label>Margins (in inches)</Form.Label>
                    <Row className="mt-3">
                      <Col>
                        <Form.Control
                          value={this.props.properties.margin ? this.props.properties.margin.top : 0}
                          onChange={(e) =>
                            changeProprtyM(
                              "margin.top",
                              e.target.value,
                              this.props,
                              this.props.updateProp
                            )
                          }
                          type="number"
                          step="0.1"
                        />
                        <Form.Text className="text-muted">Top</Form.Text>
                      </Col>
                      <Col>
                        <Form.Control
                          value={this.props.properties.margin ? this.props.properties.margin.bottom : 0}
                          onChange={(e) =>
                            changeProprtyM(
                              "margin.bottom",
                              e.target.value,
                              this.props,
                              this.props.updateProp
                            )
                          }
                          type="number"
                          step="0.1"
                        />
                        <Form.Text className="text-muted">Bottom</Form.Text>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col>
                        <Form.Control
                          value={this.props.properties.margin ? this.props.properties.margin.left : 0}
                          onChange={(e) =>
                            changeProprtyM(
                              "margin.left",
                              e.target.value,
                              this.props,
                              this.props.updateProp
                            )
                          }
                          type="number"
                          step="0.1"
                        />
                        <Form.Text className="text-muted">Left</Form.Text>
                      </Col>
                      <Col>
                        <Form.Control
                          value={this.props.properties.margin ? this.props.properties.margin.right : 0}
                          onChange={(e) =>
                            changeProprtyM(
                              "margin.right",
                              e.target.value,
                              this.props,
                              this.props.updateProp
                            )
                          }
                          type="number"
                          step="0.1"
                        />
                        <Form.Text className="text-muted">Right</Form.Text>
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <hr />
                  <Col sm={12}>
                    <Form.Group controlId="forBackgroundImageCheckbox">
                      <Form.Check
                        type="checkbox"
                        label="Show Background Image"
                        checked={
                          this.props.properties &&
                          this.props.properties.background.showImage
                        }
                        onChange={(e) =>
                          changeProprtyM(
                            "background.showImage",
                            e.target.checked,
                            this.props,
                            this.props.updateProp
                          )
                        }
                      />
                    </Form.Group>
                  </Col>
                  {this.props.properties.background.showImage && (
                    <Form.Group controlId="forBackgroundImage" className="mb-3">
                      <Form.Label>Background Image</Form.Label>
                      {!this.props.properties.background.image && (
                        <Form.Control
                          type="file"
                          className="form-control"
                          accept="image/png, image/jpeg, image/jpg"
                          onChange={(e) => this._handleBackgroundImageSelect(e)}
                        />
                      )}
                      {(this.state.backgroundImagePreview || this.props.properties.background.image) && (
                        <div className="mt-2"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                            border: "1px solid #ddd",
                            padding: "10px",
                            borderRadius: "4px",
                            width: "100%",
                          }}>
                          <div style={{
                            position: 'relative',
                            width: '100%',
                            maxWidth: '300px',
                            marginBottom: '15px',
                            display: 'flex',
                            justifyContent: 'center',
                            borderBottom: '1px solid #ccc',
                          }}>
                            <img
                              src={this.state.backgroundImagePreview}
                              alt="Background preview"
                              style={{ maxWidth: '100%', maxHeight: '150px' }}
                            />
                          </div>
                          <div className="w-100 mb-3">
                            <Form.Label>Resize Image ({this.state.backgroundImageSize}%)</Form.Label>
                            <InputGroup>
                              <Form.Control
                                type="range"
                                className="w-100"
                                min="10"
                                max="100"
                                step="5"
                                value={this.state.backgroundImageSize}
                                onChange={this._handleImageSizeChange}
                              />
                            </InputGroup>
                          </div>

                          <div className="w-100 mb-3">
                            <Form.Label>Image Opacity ({parseFloat(this.state.backgroundImageOpacity).toFixed(1)})</Form.Label>
                            <InputGroup>
                              <Form.Control
                                type="range"
                                className="w-100"
                                min="0"
                                max="1"
                                step="0.1"
                                value={this.state.backgroundImageOpacity}
                                onChange={this._handleImageOpacityChange}
                              />
                            </InputGroup>
                          </div>
                          <div className="pt-4">
                            <Button variant="outline-danger" onClick={() => this._handleRemoveBackgroundImage()}>Remove</Button>
                          </div>
                        </div>
                      )}
                    </Form.Group>
                  )}
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <Form.Group controlId="forBackgroundColorProp">
                    <Form.Check
                      type="checkbox"
                      label="Show Background Color"
                      checked={
                        this.props.properties &&
                        this.props.properties.background.showColor
                      }
                      onChange={(e) =>
                        changeProprtyM(
                          "background.showColor",
                          e.target.checked,
                          this.props,
                          this.props.updateProp
                        )
                      }
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>Background Colour</Form.Label>
                    <InputGroup>
                      {/* <FormControl
                        value={this.props.properties.background.color}
                        readOnly
                      /> */}
                      <InputGroup.Append>
                        <ColorPicker
                          {...this.props}
                          color={this.props.properties.background.color}
                          callbackFromParents={(e) => {
                            changeProprtyM(
                              "background.color",
                              e.hex,
                              this.props,
                              this.props.updateProp
                            );
                          }}
                        />
                      </InputGroup.Append>
                    </InputGroup>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="formLabelColour">
                    <Form.Label>Label Colour</Form.Label>
                    <InputGroup>
                      {/* <FormControl
                        value={this.props.properties.labelColor}
                        readOnly
                      /> */}
                      <InputGroup.Append>
                        <ColorPicker
                          {...this.props}
                          color={this.props.properties.labelColor}
                          callbackFromParents={(e) => {
                            changeProprty(
                              "labelColor",
                              e.hex,
                              this.props,
                              this.props.updateProp
                            );
                          }}
                        />
                      </InputGroup.Append>
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group controlId="formFontColour">
                    <Form.Label>Font Colour</Form.Label>
                    <InputGroup>
                      {/* <FormControl
                        value={this.props.properties.fontColor}
                        readOnly
                      /> */}
                      <InputGroup.Text className="p-0">
                        <ColorPicker
                          {...this.props}
                          color={this.props.properties.fontColor}
                          callbackFromParents={(e) => {
                            // changeProprty(
                            //   "fontColor",
                            //   e.hex,
                            //   this.props,
                            //   this.props.updateProp
                            // );
                            this._updateAllFonts(
                              e.hex,
                              this.props.properties.fontSize
                            );
                          }}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="formFontSize">
                    <Form.Label>Font Size</Form.Label>
                    <InputGroup>
                      <FormControl
                        value={this.props.properties.fontSize}
                        onChange={(e) => {
                          this._updateAllFonts(
                            this.props.properties.fontColor,
                            e.target.value
                          );
                        }}
                        type="number"
                      />
                      <InputGroup.Text>pt</InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <hr />
                  <Form.Group controlId="formMargins">
                    <Form.Label className="fw-bold mt-3">
                      Price Notification
                    </Form.Label>
                    <Row className="mt-3">
                      <Col sm={12}>
                        <Form.Group controlId="forApplyToFirstPageOnly">
                          <Form.Check
                            type="checkbox"
                            label="Send Price Change Notifications"
                            className="fw-bold"
                            value={
                              this.props.properties.isPriceChangeNotification
                            }
                            onChange={(e) =>
                              changeProprty(
                                "isPriceChangeNotification",
                                e.target.checked,
                                this.props,
                                this.props.updateProp
                              )
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Form.Group controlId="forWatermarkBackground">
                          <Form.Label>Background Colour</Form.Label>
                          <InputGroup>
                            {/* <FormControl
                              value={
                                this.props.properties.priceNotificationColour ? this.props.properties.priceNotificationColour
                                  .backgroundColour : ''
                              }
                              readOnly
                            /> */}
                            <InputGroup.Text className="p-0">
                              <ColorPicker
                                {...this.props}
                                color={
                                  this.props.properties.priceNotificationColour ? this.props.properties.priceNotificationColour
                                    .backgroundColour : ''
                                }
                                callbackFromParents={(e) => {
                                  changeProprtyM(
                                    "priceNotificationColour.backgroundColour",
                                    e.hex,
                                    this.props,
                                    this.props.updateProp
                                  );
                                }}
                              />
                            </InputGroup.Text>
                          </InputGroup>
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId="formWatermarkForeground">
                          <Form.Label>Font Colour</Form.Label>
                          <InputGroup>
                            {/* <FormControl
                              value={
                                this.props.properties.priceNotificationColour ?
                                  this.props.properties.priceNotificationColour
                                    .foreColour : ''
                              }
                              readOnly
                            /> */}
                            <InputGroup.Text className="p-0">
                              <ColorPicker
                                {...this.props}
                                color={
                                  this.props.properties.priceNotificationColour ?
                                    this.props.properties.priceNotificationColour
                                      .foreColour : ''
                                }
                                callbackFromParents={(e) => {
                                  changeProprtyM(
                                    "priceNotificationColour.foreColour",
                                    e.hex,
                                    this.props,
                                    this.props.updateProp
                                  );
                                }}
                              />
                            </InputGroup.Text>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          ) : (
            <></>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    properties: state.template.prop,
    head: state.template.head,
    total: state.template.total,
    foot: state.template.foot
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateProp: (e) => dispatch(updateProp(e)),
    updateHead: (e) => dispatch(updateHead(e)),
    updateTotal: (e) => dispatch(updateTotal(e)),
    updateFoot: (e) => dispatch(updateFoot(e)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Properties);
